import { useNavigate } from "react-router-dom"
import CardContainer from "../../components/card_container"
import useGet from "../../hooks/useGet"
import { DETAILSTYLEACCENT } from "../../routes/routes_name"
import IconInfromation from "../../assets/icons/icon_information.svg"
import "./style_accent.scss"

const StyleAccentPage = () => {
    const navigate = useNavigate()
    const {
        filter,
        isLoading,
        data,
        error,
        totalPages,
        handlePagination,
        handleLimit,
        handleFilter,
    } = useGet('/v1/style')

    return (
        <>
            <CardContainer
                title="Choose Fabrics"
                isHeader={true}
                onSearchChange={handleFilter}>
                <div className="expanded-y">
                    <div className="card-grid-content">
                        <div className="card-grid">
                            {
                                data.map((e) => {
                                    return (
                                        <div className="card-grid-cover" onClick={() => navigate(DETAILSTYLEACCENT, { state: e })}>
                                            <img src={e.fabric_image} className="card-list-img" />
                                            <div className="card-description">
                                                {
                                                    e.is_have_style === false && (
                                                        <div className="card-information">
                                                            <img src={IconInfromation} className="card-icon-information" alt="Information Icon" />
                                                            <div className="text-information">Style or accent have not been set</div>
                                                        </div>
                                                    )
                                                }
                                                <div className="card-title">{e.fabric_name}</div>
                                                <div className="card-subtitle">{e.material}</div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </CardContainer>
        </>
    )
}

export default StyleAccentPage